import React, { useState } from 'react';
import { Modal, Box, Typography, Button, CircularProgress } from '@mui/material';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
    title?: string; // Optional: Title of the modal
    message?: string; // Optional: Message displayed in the modal
    confirmLoading?: boolean; // ✅ Make confirmLoading optional
}

const ConfirmationModal: React.FC<Props> = ({
                                                isOpen,
                                                onClose,
                                                onConfirm,
                                                title = 'Confirm Action',
                                                message = 'Are you sure you want to proceed?',
                                                confirmLoading = false, // ✅ Default to false if not passed
                                            }) => {
    const [error, setError] = useState<string | null>(null);

    const handleConfirm = async () => {
        try {
            await onConfirm();
            setError(null);
        } catch (err) {
            setError('An error occurred while confirming the action. Please try again.');
        }
    };

    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box sx={{ padding: 3, backgroundColor: 'white', margin: 'auto', marginTop: '10%', width: 400, borderRadius: 2 }}>
                <Typography variant="h6" gutterBottom>{title}</Typography>
                <Typography variant="body1" gutterBottom>{message}</Typography>

                {error && <Typography variant="body2" sx={{ color: 'red', marginBottom: 2 }}>{error}</Typography>}

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2, gap: 2 }}>
                    <Button variant="contained" onClick={onClose} disabled={confirmLoading}
                            sx={{ backgroundColor: '#F44336 !important', color: 'white !important', '&:hover': { backgroundColor: '#D32F2F !important' } }}>
                        Cancel
                    </Button>

                    <Button variant="contained" onClick={handleConfirm} disabled={confirmLoading}
                            sx={{ backgroundColor: '#4CAF50 !important', color: 'white !important', '&:hover': { backgroundColor: '#45A049 !important' } }}>
                        {confirmLoading ? <CircularProgress size={24} color="inherit" /> : 'Confirm'}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default ConfirmationModal;